module.exports = __webpack_public_path__ + "img/other_pay_wechatpay.7f5d5c5e.svg";